<template>
  <!-- 藏品专题详情 -->
  <div class="page-collect-topic-detail">
    <div class="m-banner-top">
      <div class="top-box">
        <div class="label-box">
          <h1 class="tc mb-20">{{detailData.title}}</h1>
          <p class="price"><span><i>¥ </i>{{detailData.price}}</span></p>
          <p class="txt"><label>规格：</label>{{detailData.ext1}}</p>
          <p class="txt"><label>类别：</label>{{detailData.ext3}}</p>
        </div>

        <div class="pic-box" v-if="detailData.attId">
          <img v-lazy="detailData.attId">
        </div>
      </div>
    </div>

    <div class="g-content-wrap">
      <!-- <div class="slides-box">
        <div class="pic-box">
          <img v-lazy="detailData.attId" alt="">
        </div>
        <div class="pic-info g-border-box trans">
          <div class="g-border">
            <h2 class="title">{{detailData.title}}</h2>
            <p>规格：{{detailData.ext1}}</p>
            <p>类别：{{typeChinese(detailData.typeId) || ''}}</p>
            <p class="price">价格：<span style="font-size:30px"><i style="font-size:16px;">¥ </i>{{detailData.price}}</span></p>

            <div class="btn-box mt-40" v-if="detailData.url">
              <a class="g-btn-level-1" :href="detailData.url" target="_blank">立即购买</a>
            </div>
          </div>
        </div>
      </div> -->

      <h2>产品简介</h2>
      <div class="g-detail-html trans" v-html="detailData.subject"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailId: this.$route.query.id,
      detailData: {
        content: ''
      },
      typeList: [],
    }
  },
  methods: {
    getDetailData() {
      this.$http
        .get('../singleMuseum/applet/culturalCreativity/detail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getDictData() {
      this.$http
        .get('../singleMuseum/collectDict/getSelectDataByKey?key=cc_type', {
        }).then(res => {
          if (res.success) {
            this.typeList = res.result

            this.getDetailData()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    typeChinese(typeId){
      let dictName
      this.typeList.map(item => {
        if(item.dictCode === typeId){
          dictName = item.dictName
        }
      })
      return dictName
    }
  },
  created() {
    this.getDictData()
    // this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.page-collect-topic-detail {
  h2 {
    margin: 70px 0 40px;
    font-size: 24px;
    color: #000;
  }
  .price {
    color: $primary;
    font-size: 24px;
    margin-bottom: 20px;
  }
  // .slides-box {
  //   margin-bottom: 40px;
  //   display: flex;
  //   .pic-box {
  //     img {
  //       width: 800px;
  //       height: 600px;
  //       // object-fit: contain;
  //       // background: #f6f6f6;
  //     }
  //   }
  //   .pic-info {
  //     flex: 1;
  //     background: #F6F6F6;
  //     margin-left: 40px;
  //     h2 {
  //       padding-top: 100px;
  //       font-size: 44px;
  //       line-height: 50px;
  //       margin-bottom: 50px;
  //     }
  //     p {
  //       margin-top: 20px;
  //       font-size: 16px;
  //       line-height: 24px;
  //     }
  //     .price {
  //       margin-top: 30px;
  //     }
  //   }
  // }

  .g-detail-html {
    width: 1053px;
  }
}
</style>

